import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface OptionState {
  selectedOption: string | null;
  selectedIndex: number[];
  sessionId: string | null;
  setSelectedOption: (value: string) => void;
  setSelectedIndex: (index: number) => void;
  setSessionId: (id: string | null) => void;
  clearData: () => void;
}

export const useOptionStore = create<OptionState>()(
  persist(
    set => ({
      selectedOption: null,
      selectedIndex: [],
      sessionId: null,

      setSelectedOption: value => set({ selectedOption: value }),

      setSelectedIndex: index =>
        set(state => ({
          selectedIndex: state.selectedIndex.includes(index)
            ? state.selectedIndex
            : [...state.selectedIndex, index],
        })),

      setSessionId: id => set({ sessionId: id }),

      clearData: () =>
        set({
          selectedIndex: [],
          selectedOption: null,
          sessionId: null,
        }),
    }),
    {
      name: 'option-store',
    }
  )
);
